<template>
  <f7-page name="ccm-matchbook-study" class="page-bg-render">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        교재 학습
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

		<div style="padding:8px;">
			<button class="button button-outline float-right" style="width:unset; line-height: 1;" @click="addMatchBookDialog()">
				<i class="f7-icons" style="vertical-align:middle">plus</i>
				<span style="vertical-align:middle"> 교재등록</span>
			</button>
		</div>

    <f7-block-title>
			<span>등록된 교재 목록</span>
		</f7-block-title>
		<div class="list media-list">
			<ul>
				<template v-for="(item, i) in bookList">
					<li :key="'ii' + i">
						<a href="#" class="item-link item-content" @click="showMBPageExamNoModal(i)">
							<div class="item-media"><img :src="bookImageUrl(item.BOOKIMAGE_NO)"/></div>
							<div class="item-inner">
								<div class="item-title-row">
									<div class="item-title">{{item.MATCHBOOK_NAME}}</div>
									<div class="item-after">학습하기</div>
								</div>
								<div class="item-subtitle">{{getCourseName(i)}}</div>
								<div class="item-text">
									<simple-progress :value-title="getProgressTitle(i)" :unit-count="item.EXAM_CNT" :start-percent="((item.START_EXAM_SEQ-1) * 100 / item.EXAM_CNT)" :end-percent="((item.END_EXAM_SEQ) * 100  / item.EXAM_CNT)"></simple-progress>
								</div>
							</div>
						</a>
					</li>
				</template>
			</ul>
		</div>

  </f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

import SimpleProgress from '../../../components/progress/simple-progress.vue';
//import func from '../../../../vue-temp/vue-editor-bridge';

export default {
	components: {
		SimpleProgress
	},
  data() {
    return {		
      bookList: []
    }
	},
  mounted() {
		const _this  = this;
		_this.loadMyMatchBookList();   
		$(document).on('page:reinit', '.page[data-name="ccm-matchbook-study"]', _this.loadMyMatchBookList);
	},
  methods: {
		
		getCourseName(itemIndex) {
			const _this = this;
			var item = _this.bookList[itemIndex];
			var courseId = item.GRADE_ID + item.SEMESTER_ID;
			var courseName = CONST.courseMap[courseId].name;
	
			return courseName;
		},
		getProgressTitle(itemIndex){
			var _this = this;
			var item = _this.bookList[itemIndex];
			var title = "학습시작 대기중";
			
			if(item.END_EXAM_SEQ > 0) {
				title = item.END_PAGE_NO+"p."+item.END_EXAM_NO+".";
			}

			return title;		
		},	
		bookImageUrl(bookImageNo) {			
			return MODULE.Util.getMatchBookImageUrl(bookImageNo);			
		},
		showMBPageExamNoModal(itemIndex) {
			const _this = this;			
			var item = _this.bookList[itemIndex];
			var url = PAGES.SUB_CCM_MATCHBOOK_ADD_EXAM;
			var code = MODULE.Util.keyToCode(CONST.matchBookCodePrefix, item.MATCHBOOK_KEY);
		
			let param = {				
				matchBookName : item.MATCHBOOK_NAME,
				matchBookKey : item.MATCHBOOK_KEY,
				matchBookCode : code,
				startPageNo : item.START_PAGE_NO,
				endPageNo : item.END_PAGE_NO,
				startExamNo : item.START_EXAM_NO,
				endExamNo : item.END_EXAM_NO
			}
   
			PAGES.popPage(url, param);   	
		},
		addMatchBookDialog() {
			const _this = this;
			_this.$f7.dialog.prompt('등록할 매칭북 코드 입력.', "안내", function (code) {
				
				var perfix  = MODULE.Util.codePrefix(code);

				if(perfix == CONST.matchBookCodePrefix) {
					var codeKey = MODULE.Util.codeToKey(CONST.matchBookCodePrefix, code);							
					_this.addMatchBook(codeKey);
				}else {
					MODULE.DialogBox.message("에러", "잘못된 코드입니다.<br/>코드를 확인하세요.");
        	return;
				}

			});
		},
		addMatchBook(codeKey){
			const _this = this;
			
			let param = {
				pMatchBookKey : codeKey
			};

			API.ajaxRequest({
				url: API.addMyMatchBook(),
				data: param
			}).then(function(data) {
				_this.loadMyMatchBookList();
			}).catch(function(code) {

				if(CONST.resultCode.NOT_EMPTY){
					MODULE.DialogBox.message("에러", "이미 등록된 교재입니다.");        	
				}else{
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				}
				
			});

		},
		loadMyMatchBookList() {
			const _this = this;
			let param = {};
						
			API.ajaxRequest({
				url: API.getMyMatchBookList(),
				data: param
			}).then(function(data) {
				_this.bookList = data.bookList;
			}).catch(function(code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		}
  }
}

</script>